import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
  BreakPointDesktop,
} from "../../../constants/dimension";
import BgConsoleCard from "../../../assets/console/bg-console-card.webp";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    [BreakPointDesktop]: {
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  content: {
    padding: theme.spacing.space24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    backgroundImage: `url(${BgConsoleCard})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    borderRadius: theme.radius.medium,
    marginTop: theme.spacing.space24 + 1,
    position: "relative",
    [BreakPointDesktop]: {
      marginTop: "initial",
      height: "100%",
    },
  },
  action: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    marginTop: theme.spacing.space24,
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    marginTop: theme.spacing.space24,
    [BreakPointDesktop]: {
      marginTop: theme.spacing.space16,
    },
  },
  activeDot: {
    backgroundColor: "#3CB84E",
    height: 16,
    width: 16,
    borderRadius: theme.radius.medium,
    "&.expire-soon": {
      backgroundColor: "#DD9D1C",
    },
    "&.grace": {
      backgroundColor: "#DD9D1C",
    },
    "&.expired": {
      backgroundColor: theme.colors.NotificationError,
    },
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
    // webOS 22 (Chromium <=87): outline ignores border-radius; box-shadow follows it
    "@supports not (aspect-ratio: 1 / 1)": {
      outline: "none",
      boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.80)",
    },
  },
  mainLogo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    [BreakPointMobile]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    [BreakPointTablet]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  console: {
    position: "absolute",
    right: theme.spacing.space24,
    marginTop: `-${theme.spacing.space48 + theme.spacing.space2}px`,
    [BreakPointDesktop]: {
      marginTop: "initial",
      position: "initial",
      height: "100%",
    },
    "&.moreSpace": {
      height: 210,
    },
  },
  container: {
    width: "100%",
  },
  status: {
    width: "70%",
    [BreakPointDesktop]: {
      width: "initial",
    },
  },
}));
